/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaAnagraficaUpdateForm { 
    form_data?: { [key: string]: any; };
    modes_anagrafica?: { [key: string]: PraticaAnagraficaUpdateFormModesAnagraficaEnum; };
    version: number;
}
export enum PraticaAnagraficaUpdateFormModesAnagraficaEnum {
    PRESA_IN_CARICO = 'PRESA_IN_CARICO',
    AGGIORNA = 'AGGIORNA',
    SOVRASCRIVI_ORIGINALE = 'SOVRASCRIVI_ORIGINALE'
};



